import { Flex, Tag, Tooltip, Typography } from '@project44/manifest-ds';

const styles = {
  tag: {
    backgroundColor: '$palette-indigo-50',
    color: '$palette-indigo-800',
    flex: 1,
  },
  text: {
    flex: 3.5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

interface ICellTagged {
  text: string;
  label: string;
  labelTooltip: string;
}

// TODO reenable all tooltips when clickthrough allowed
function CellTagged({ text, label, labelTooltip }: ICellTagged) {
  return (
    <Flex
      align="center"
      gap="small"
      css={{ width: 'fit-content', pointerEvents: 'none' }}
    >
      <Tooltip title={labelTooltip}>
        <Tag css={styles.tag} children={label} />
      </Tooltip>
      <Tooltip title={text}>
        <Typography variant="subtextBold" children={text} css={styles.text} />
      </Tooltip>
    </Flex>
  );
}

export default CellTagged;
